import {
    DeploymentUnitOutlined,
    GlobalOutlined,
    PartitionOutlined,
    ShareAltOutlined,
    SolutionOutlined,
    StarOutlined,
    TeamOutlined
} from "@ant-design/icons";
import ReligionCountListPage from "../pages/admin/religion/ReligionCountListPage";
import ReligionCountEditPage from "../pages/admin/religion/ReligionCountEditPage";
import AcficCountListPage from "../pages/admin/acfic/AcficCountListPage";
import AcficCountEditPage from "../pages/admin/acfic/AcficCountEditPage";
import AcficMemberListPage from "../pages/admin/acfic/AcficMemberListPage";
import AcficMemberEditPage from "../pages/admin/acfic/AcficMemberEditPage";
import HmtoListPage from "../pages/admin/hmto/HmtoListPage";
import HmtoEditPage from "../pages/admin/hmto/HmtoEditPage";
import HomeMapDataListPage from "../pages/admin/home_map_data/HomeMapDataListPage";
import HomeMapDataEditPage from "../pages/admin/home_map_data/HomeMapDataEditPage";
import NationCountListPage from "../pages/admin/nation/NationCountListPage";
import NationCountEditPage from "../pages/admin/nation/NationCountEditPage";
import NewStratumPersonnelListPage from "../pages/admin/new_stratum/NewStratumPersonnelListPage";
import NewStratumPersonnelEditPage from "../pages/admin/new_stratum/NewStratumPersonnelEditPage";
import NewStratumWorkUnitListPage from "../pages/admin/new_stratum/NewStratumWorkUnitListPage";
import NewStratumWorkUnitEditPage from "../pages/admin/new_stratum/NewStratumWorkUnitEditPage";
import NonalignedListPage from "../pages/admin/partywork/NonalignedListPage";
import NonalignedEditPage from "../pages/admin/partywork/NonalignedEditPage";
import NonpartyIntellectualsListPage from "../pages/admin/partywork/NonpartyIntellectualsListPage";
import NonpartyIntellectualsEditPage from "../pages/admin/partywork/NonpartyIntellectualsEditPage";
import PartyMemberListPage from "../pages/admin/partywork/PartyMemberListPage";
import PartyMemberEditPage from "../pages/admin/partywork/PartyMemberEditPage";
import HkEnterpriseListPage from "../pages/admin/hmto/HkEnterpriseListPage";
import HkEnterpriseEditPage from "../pages/admin/hmto/HkEnterpriseEditPage";
import TwEnterpriseListPage from "../pages/admin/hmto/TwEnterpriseListPage";
import TwEnterpriseEditPage from "../pages/admin/hmto/TwEnterpriseEditPage";

export const privateOnlyRouters = {
    mainTemplateRouters: [
        {
            name: "各地数据统计",
            isPrivate: true,
            isPublic: false,
            path: "/region_statistics",
            auth: "religion_venue",
            icon: <PartitionOutlined/>,
            component: <HomeMapDataListPage/>
        },
        {
            name: "数据统计信息编辑",
            isPrivate: true,
            isPublic: false,
            path: "/home_map_data/edit",
            auth: "religion_venue",
            hidden: true,
            component: <HomeMapDataEditPage/>
        },
        {
            name: "工商联信息",
            icon: <TeamOutlined/>,
            children: [
                {
                    name: "会员人数",
                    isPrivate: true,
                    isPublic: false,
                    path: "/acfic_count",
                    auth: "religion_venue",
                    component: <AcficCountListPage/>
                },
                {
                    name: "会员人数编辑",
                    isPrivate: true,
                    isPublic: false,
                    path: "/acfic_count/edit",
                    auth: "religion_venue",
                    hidden: true,
                    component: <AcficCountEditPage/>
                },
                {
                    name: "人员统计",
                    isPrivate: true,
                    isPublic: false,
                    path: "/acfic_member",
                    auth: "religion_venue",
                    component: <AcficMemberListPage/>
                },
                {
                    name: "人员信息编辑",
                    isPrivate: true,
                    isPublic: false,
                    path: "/acfic_member/edit",
                    auth: "religion_venue",
                    hidden: true,
                    component: <AcficMemberEditPage/>
                },
            ]
        },
        {
            name: "港澳台侨信息",
            icon: <GlobalOutlined/>,
            children: [
                {
                    name: "人员统计",
                    isPrivate: true,
                    isPublic: false,
                    path: "/hmto",
                    auth: "religion_venue",
                    component: <HmtoListPage/>
                },
                {
                    name: "人员信息编辑",
                    isPrivate: true,
                    isPublic: false,
                    path: "/hmto/edit",
                    auth: "religion_venue",
                    hidden: true,
                    component: <HmtoEditPage/>
                },
                {
                    name: "港资企业统计",
                    isPrivate: true,
                    isPublic: false,
                    path: "/hongkong_owned_enterprise",
                    auth: "religion_venue",
                    component: <HkEnterpriseListPage/>
                },
                {
                    name: "港资企业编辑",
                    isPrivate: true,
                    isPublic: false,
                    path: "/hongkong_owned_enterprise/edit",
                    auth: "religion_venue",
                    hidden: true,
                    component: <HkEnterpriseEditPage/>
                },
                {
                    name: "台资企业统计",
                    isPrivate: true,
                    isPublic: false,
                    path: "/taiwan_owned_enterprise",
                    auth: "religion_venue",
                    component: <TwEnterpriseListPage/>
                },
                {
                    name: "台资企业编辑",
                    isPrivate: true,
                    isPublic: false,
                    path: "/taiwan_owned_enterprise/edit",
                    auth: "religion_venue",
                    hidden: true,
                    component: <TwEnterpriseEditPage/>
                },
            ]
        },
        {
            name: "新社会阶层信息",
            icon: <ShareAltOutlined/>,
            children: [
                {
                    name: "人员统计",
                    isPrivate: true,
                    isPublic: false,
                    path: "/new_stratum_personnel",
                    auth: "religion_venue",
                    component: <NewStratumPersonnelListPage/>
                },
                {
                    name: "新社会阶层人员编辑",
                    isPrivate: true,
                    isPublic: false,
                    path: "/new_stratum_personnel/edit",
                    auth: "religion_venue",
                    hidden: true,
                    component: <NewStratumPersonnelEditPage/>
                },

                {
                    name: "工作地点统计",
                    isPrivate: true,
                    isPublic: false,
                    path: "/new_stratum_work_unit",
                    auth: "religion_venue",
                    component: <NewStratumWorkUnitListPage/>
                },
                {
                    name: "新社会阶层工作地点编辑",
                    isPrivate: true,
                    isPublic: false,
                    path: "/new_stratum_work_unit/edit",
                    auth: "religion_venue",
                    hidden: true,
                    component: <NewStratumWorkUnitEditPage/>
                },
            ]
        },
        {
            name: "党派工作信息",
            icon: <StarOutlined/>,
            children: [
                {
                    name: "无党派代表",
                    isPrivate: true,
                    isPublic: false,
                    path: "/nonaligned",
                    auth: "religion_venue",
                    component: <NonalignedListPage/>
                },
                {
                    name: "无党派代表人员信息编辑",
                    isPrivate: true,
                    isPublic: false,
                    path: "/nonaligned/edit",
                    auth: "religion_venue",
                    hidden: true,
                    component: <NonalignedEditPage/>
                },
                {
                    name: "党外知识分子",
                    isPrivate: true,
                    isPublic: false,
                    path: "/nonparty_intellectuals",
                    auth: "religion_venue",
                    component: <NonpartyIntellectualsListPage/>
                },
                {
                    name: "党外知识分子信息编辑",
                    isPrivate: true,
                    isPublic: false,
                    path: "/nonparty_intellectuals/edit",
                    auth: "religion_venue",
                    hidden: true,
                    component: <NonpartyIntellectualsEditPage/>
                },
                {
                    name: "党派人员",
                    isPrivate: true,
                    isPublic: false,
                    path: "/party_member",
                    auth: "religion_venue",
                    component: <PartyMemberListPage/>
                },
                {
                    name: "党派人员信息编辑",
                    isPrivate: true,
                    isPublic: false,
                    path: "/party_member/edit",
                    auth: "religion_venue",
                    hidden: true,
                    component: <PartyMemberEditPage/>
                },
            ]
        },
        {
            name: "少数民族统计",
            isPrivate: true,
            isPublic: false,
            path: "/nation_count",
            auth: "religion_venue",
            icon: <DeploymentUnitOutlined/>,
            component: <NationCountListPage/>
        },
        {
            name: "少数民族人数编辑",
            isPrivate: true,
            isPublic: false,
            path: "/nation_count/edit",
            auth: "religion_venue",
            hidden: true,
            component: <NationCountEditPage/>
        },
        {
            name: "信众人数统计",
            isPrivate: true,
            isPublic: false,
            path: "/religion_count",
            auth: "religion_venue",
            icon: <SolutionOutlined/>,
            component: <ReligionCountListPage/>
        },
        {
            name: "信众人数编辑",
            isPrivate: true,
            isPublic: false,
            path: "/religion_count/edit",
            auth: "religion_venue",
            hidden: true,
            component: <ReligionCountEditPage/>
        },
    ]
}